import { createSelector } from '@ngrx/store';

import { createEntityCollectionStore, ID, memoizeSelector } from '@recruitee/ngrx';

import { AvailableFlowsEntity } from './available-flows.types';

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<AvailableFlowsEntity>()('RequisitionsAvailableFlows', {});

const assigned = memoizeSelector((id: ID) =>
  createSelector(selectors.byId(id), entity => entity?.approvalFlows.find(flow => !!flow.assigned)),
);

const AvailableFlowsSelectors = {
  ...selectors,
  assigned,
};

export {
  AvailableFlowsSelectors,
  actions as AvailableFlowsActions,
  reducer as AvailableFlowsReducer,
  namespace as AvailableFlowsNamespace,
};
